export const ARROW_TYPE = {
    chevron: 'chevron',
    default: 'default',
    line: 'line',
    play: 'play',
} as const;
export const ARROW_SIZE = {
    default: 'default',
    lg: 'lg',
    m: 'm',
    sm: 'sm',
    xl: 'xl',
} as const;
